import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Car, Search } from "lucide-react";

export default function Vehicles() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/vehicles").then((r) => setRows(r.data)); }, []);

  const filtered = rows.filter((v) =>
    !q || v.car_number.toLowerCase().includes(q.toLowerCase()) ||
    (v.last_vehicle || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="p-8 space-y-6" data-testid="vehicles-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="overline">// vehicles · digital service file</div>
          <h1 className="font-display font-black text-3xl mt-1">Vehicles</h1>
          <p className="text-zinc-500 text-sm mt-1">{rows.length} unique car numbers diagnosed across all mechanics.</p>
        </div>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-zinc-600" />
          <input
            data-testid="vehicles-search"
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="search plate or vehicle..."
            className="bg-[#090A0B] border border-zinc-800 pl-8 pr-3 py-2 text-sm font-mono-data focus:border-amber-500 outline-none w-72"
          />
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map((v) => (
          <Link key={v.car_number} to={`/vehicles/${encodeURIComponent(v.car_number)}`}
            data-testid={`vehicle-card-${v.car_number}`}
            className="gs-card p-4 block hover:border-amber-500/40 transition-colors">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2">
                <Car className="w-4 h-4 text-amber-500" />
                <span className="font-mono-data text-base font-bold text-amber-300 tracking-wider">{v.car_number}</span>
              </div>
              <span className="confidence-badge whitespace-nowrap">{v.query_count} {v.query_count === 1 ? "query" : "queries"}</span>
            </div>
            <div className="mt-2 text-xs text-zinc-500">
              {v.last_vehicle || "Unknown vehicle"} · last by <span className="text-zinc-300">{v.last_mechanic || "—"}</span>
            </div>
            {v.dtc_codes.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-2">
                {v.dtc_codes.slice(0, 4).map((c) => <span key={c} className="dtc-badge">{c}</span>)}
              </div>
            )}
          </Link>
        ))}
        {filtered.length === 0 && <div className="text-zinc-600 text-sm">No vehicles yet. Run a diagnostic with a car number from the Simulator.</div>}
      </div>
    </div>
  );
}
